import React from 'react'
import i18n from "../../../i18next";

import TimeLineIcon from './TimeLineIcon';
import { getPriceWithCurrencySymbol } from '../../../utils/CommonUtils';

const TimeLineItem = props => {

    //do if-else logic when we are going to use the left-sided items

    const { mainItemContainer, rightContainer, messageText, messageTextRight, messageTimeRight, messageTime } = styles;

    if (props.item.type === 'NOTIFICATION_EMAIL' || props.item.type === 'NOTIFICATION_SMS') {
        return (
            <div style={rightContainer}>
                <div style={{ marginRight: '10px' }}>
                    <div style={messageTextRight}>{formatMessage(props.item, props.currency)}</div>
                    <div style={messageTimeRight}>{props.item.date}</div>
                </div>
                <TimeLineIcon item={props.item} />
            </div>
        );

    } else {
        return (
            <div style={mainItemContainer}>
                <TimeLineIcon item={props.item} />
                <div style={{ marginLeft: '10px' }}>
                    <div style={messageText}>{formatMessage(props.item, props.currency)}</div>
                    <div style={messageTime}>{props.item.date}</div>
                </div>
            </div>
        );
    }
}

const formatMessage = (item, currency) => {

    switch (item.type) {
        case 'ORDER': {
            return `${i18n.t('screens:customerInsightScreen.placed')} "${i18n.t('screens:customerInsightScreen.' + item.message)}" ${i18n.t('screens:customerInsightScreen.order')} (${getPriceWithCurrencySymbol(item.total, currency)})`
        }
        case 'PROMOTION': {
            return `"${item.message}" ${i18n.t('screens:customerInsightScreen.promotionRedeemed')}`;
        }
        case 'REFUND': {
            return `${i18n.t('screens:customerInsightScreen.refunded')} (-${getPriceWithCurrencySymbol(item.total, currency)}). ${i18n.t('screens:customerInsightScreen.reason')}: ${item.message}`;
        }
        case 'NOTIFICATION_EMAIL': {
            return `"${item.message}" ${i18n.t('screens:customerInsightScreen.emailSent')}`;
        }
        case 'NOTIFICATION_SMS': {
            return `"${item.message}" ${i18n.t('screens:customerInsightScreen.smsSent')}`;
        }
        default: return null;
    }

}

export default TimeLineItem;

const styles = {
    mainItemContainer: {
        margin: '0 0 15px 0',
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        left: '-25px'
    },
    rightContainer: {
        margin: '0 0 15px 0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        position: 'relative',
        right: '-27px'
    },
    messageText: {
        fontSize: '12px',
        fontWeight: 'bold'
    },
    messageTextRight: {
        fontSize: '12px',
        fontWeight: 'bold',
        textAlign: 'right'
    },
    messageTime: {
        fontSize: '10px',
        fontStyle: 'italic'
    }, 
    messageTimeRight: {
        fontSize: '10px',
        fontStyle: 'italic',
        textAlign: 'right'
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/customerInsightScreen/TimeLineItem.js